export default "__VITE_ASSET__CJv1sIdh__"